import HeaderContainer from '~/components/HeaderContainer/HeaderContainer';
import RoomOptionsContainer from '~/components/RoomOptionsContainer/RoomOptionsContainer';
import AlertContainer from '~/components/AlertContainer/AlertContainer';
import VideoContainer from '~/components/VideoContainer/VideoContainer';
import MessageContainer from '~/components/MessageContainer/MessageContainer';
import MediaContainer from '~/components/MediaContainer/MediaContainer';
import RoomContainer from '~/components/RoomContainer/RoomContainer';
import PeopleContainer from '~/components/PeopleContainer/PeopleContainer';
import ChatControls from '~/components/ChatControls/ChatControls';
import PrivateChatContainer from '~/components/PrivateChatContainer/PrivateChatContainer';
import EmoticonContainer from '~/components/EmoticonContainer/EmoticonContainer';
import PrivateChatPopupContainer from '~/components/PrivateChatInvitationContainer/PrivateChatInvitationContainer';
import GlobalAvatarLightbox from '~/components/AvatarLightbox/GlobalAvatarLightbox';
// Websocket jest renderowany w App.tsx (jeden globalny socket dla całej aplikacji).
import styles from '~/styles/AppContainer.module.css';
import Footer from './Footer/Footer';

function AppContainer() {
  const handleClick = (e: any) => {
    // console.log(e.target);
  }

  return (
    <div data-compoent="AppContainer" className={styles.appContainer} onClick={handleClick}>
      <HeaderContainer />
      <RoomOptionsContainer />
      <VideoContainer />
      <MessageContainer />
      <RoomContainer />
      <PeopleContainer />
      <PrivateChatContainer />
      <PrivateChatPopupContainer />
      <EmoticonContainer />
      <ChatControls />
      {/* <Footer /> */}

      {/* Niewidoczne kontenery */}
      <AlertContainer />
      <MediaContainer />
      <GlobalAvatarLightbox />
    </div>
  );
};

export default AppContainer;
